import { render } from "./IconChevronUpSmall.vue?vue&type=template&id=01467e40"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconChevronUpSmall.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "01467e40"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('01467e40', __exports__)) {
    api.reload('01467e40', __exports__)
  }
  
  module.hot.accept("./IconChevronUpSmall.vue?vue&type=template&id=01467e40", () => {
    api.rerender('01467e40', render)
  })

}


export default __exports__